export const InstallSync = {
  P: {
    color: 'inactive',
    margin: '0',
    text: '{{ learn.install.syncStep | polyglot }}'
  },
  Terminal: {
    width: 'fit-content',
    margin: 'A 0 Z -Y',
    value: (el) => {
      const pkg = el.getRootState?.()?.pkgManager
      return pkg === 'npm'
        ? 'npm i @symbo.ls/cli -g'
        : pkg === 'yarn'
          ? 'yarn add smbls global'
          : pkg === 'pnpm'
            ? 'pnpm add smbls global'
            : 'npm i @symbo.ls/cli -g'
    }
  },
  Flex: {
    gap: 'C1',
    TerminalWithTitle_fetch: {
      margin: 'A - -',
      Title: {
        text: '{{ learn.install.oneTimeFetch | polyglot }}'
      },
      Terminal: {
        margin: '0 0 0 -Y',
        value: 'smbls fetch'
      }
    },
    TerminalWithTitle_sync: {
      margin: 'A - -',
      Title: {
        text: '{{ learn.install.listenChanges | polyglot }}'
      },
      Terminal: {
        margin: '0 0 0 -Y',
        value: 'smbls sync'
      }
    }
  }
}
